import IconButton from 'LuxKit/Button/IconButton'
import LineArrowDownIcon from 'LuxKit/Icons/line/LineArrowDownIcon'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'

interface MaldivesCharterDateRowFareToggleProps {
  expanded: boolean
  disabled: boolean
  onToggle: () => void
  expandAriaLabel: string
  collapseAriaLabel: string
  unavailableAriaLabel: string
}

function MaldivesCharterDateRowFareToggle(props: MaldivesCharterDateRowFareToggleProps) {
  const {
    expanded,
    disabled,
    onToggle,
    expandAriaLabel,
    collapseAriaLabel,
    unavailableAriaLabel,
  } = props

  const ariaLabel = disabled ? unavailableAriaLabel : (expanded ? collapseAriaLabel : expandAriaLabel)

  return (
    <IconButton
      type="button"
      kind="secondary"
      variant="default"
      shape="square"
      size="small"
      isSelected={expanded}
      disabled={disabled}
      onClick={onToggle}
      aria-expanded={expanded}
      aria-label={ariaLabel}
    >
      {expanded ? <LineArrowDownIcon size="M" /> : <LineArrowRightIcon size="M" />}
    </IconButton>
  )
}

export default MaldivesCharterDateRowFareToggle
